define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var BaseTableViewController = require('web-agent-framework/BaseTableViewController');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var MessagingUtils = require('web-agent-utils/MessagingUtils');
    var FilterMultiSelectListViewController = require('web-agent-components/FilterMultiSelectListViewController');
    var FilterDurationViewController = require('web-agent-components/FilterDurationViewController');
    var DurationInputViewController = require('web-agent-viewControllers/DurationInputViewController');

    var conversationStates = [];

    var BaseConnectionsListTableViewController = BaseTableViewController.extend({
        ControllerName: "BaseConnectionsListTableViewController",
        applicationType: "BaseConnectionsListTableViewController",
        modelController: lpTag.WebAgent.AppMediator,
        loadingTimeout: 600000,
        LPViewMap: {
            consumerLink: '.lpview_consumerLink'
        },
        LPPrefixMap: {
            myConnectionsList: "MY_CONNECTIONS_LIST",
            appConnectionsList: "APP_CONNECTIONS_LIST"
        },
        LPClassesMap: {
            connectionsListTable: 'connections_list_table',
            hyperlink: 'bluelink'
        },
        conversationStates: {
            closed: "chat_close",
            open: "chat_open"
        },

        translationTexts: {
            openState: "STATE_IN_CONVERSATION",
            closedState: "STATE_CLOSED_CONVERSATION",
            closedStateAgent: "STATE_CLOSED_CONVERSATION_AGENT",
            closedStateConsumer: "STATE_CLOSED_CONVERSATION_CONSUMER",
            connectionsStateFilterOpen: "CONNECTIONS_STATE_FILTER_OPEN",
            connectionsStateFilterFirstTime: "CONNECTIONS_STATE_FILTER_FIRST_TIME",
            connectionsStateFilterUrgent: "CONNECTIONS_STATE_FILTER_URGENT",
            connectionsStateFilterOverdue: "CONNECTIONS_STATE_FILTER_OVERDUE",
            connectionsStateFilterClose: "CONNECTIONS_STATE_FILTER_CLOSE",
            connectionsStateFilterInQueue: "CONNECTIONS_STATE_FILTER_IN_QUEUE"
        },

        initialize: function (constructorData) {
        },

        events: function () {
        },

        render: function () {
            this.addClass(this.view, this.LPClassesMap.connectionsListTable);
        }
    });

    BaseConnectionsListTableViewController.prototype.getConfiguration = function () {
        var modelController = this.getModelControllerInstance();
        var configuration = {
            updateQueryCallback: modelController.updateQuery,
            context: this,
            tableName: this.applicationType,
            tableClass: this.tableClass,
            globalData: {
                modelController: lpTag.WebAgent.AppMediator,//modelController,
                tableName: this.applicationType
            },
            tableHead: {
                columnsData: this.getColumnsData()
            },
            tableBody: {
                htmlTable: true,
                ignoreRowHover: true,
                ignoreSectionHover: true,
                rowTemplateFile: 'LP_base_connections_list_row.html',
                dataRenderer: this.dataRenderer,
                dataBinder: this.dataBinder,
                supportKeysNavigation: true
            }
        };
        return configuration;
    };

    BaseConnectionsListTableViewController.prototype.dataRenderer = {
        numberOfSections: function (data) {
            return 1;
        },
        numberOfRowsInSection: function (data, sectionIndex) {
            return data.length;
        },
        dataForSection: function (data, sectionIndex) {
            // The data will be injected to the section template.
        },
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var self = this;
            var value = {
                badges: '',
                almostOverdue: ''
            };
            if (!data[rowIndex]) {
                return value;
            }

            //Retrieve the participant info. If it's false, exit immediately
            var conversationInfo = data[rowIndex];
            var darkLine = rowIndex % 2 === 0 ? 'dark_line' : '';
            var isAlmostOverdue = conversationInfo.responseTime && conversationInfo.responseTime.SlaTexts && conversationInfo.responseTime.SlaTexts.almostOverdue;
            var consumerProfile = conversationInfo.consumerProfile || {};

            var participantSerialNumber, participantTag;
            if (consumerProfile.userId && lpTag.WebAgent.logicController.isAcceptedEngagement(consumerProfile.userId)) {
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(consumerProfile.userId);
                participantSerialNumber = self.getModelParam(participantPath + '.participantInfo.visitorSerialNumber');
                participantTag = self.getModelParam(participantPath + '.participantTag');
            }

            _.assign(value, MessagingUtils.getStateValues(conversationInfo.state, conversationInfo.closeReason));
            _.assign(value, MessagingUtils.getBadgesValues(conversationInfo.badges, conversationInfo.state, isAlmostOverdue));
            _.assign(value, MessagingUtils.getConsumerInfo(consumerProfile.fullName, consumerProfile.description || consumerProfile.mobileNum, consumerProfile.imgUrl, true));
            _.assign(value, MessagingUtils.getParticipantInfo(participantSerialNumber, participantTag));
            _.assign(value, MessagingUtils.getUnreadMessagesValues(conversationInfo.loggedInAgentUnreadCount));

            setSLA();
            setLastContentEventNotification(this);
            setStartTime();
            setSkill();
            setSourceDevice();
            setSource();

            return {
                // general data
                id: conversationInfo.convId,
                darkLine: darkLine,

                // state related
                state: value.state,
                stateTooltip: value.stateTooltip,
                closeReason: value.closeReason,

                // badges
                badges: value.badges,
                firstTimeTooltip: value.firstTimeTooltip,
                urgentTooltip: value.urgentTooltip,
                overdueTooltip: value.overdueTooltip,
                inQueueTooltip: value.inQueueTooltip,

                // consumer info
                name: value.name,
                nameTooltip: value.name,
                serialNumber: value.serialNumber,
                participantTag: value.participantTag,
                phoneNumber: value.phoneNumber,
                showImage: value.showImage,
                customImage: value.customImage,
                consumerLinkClassName: value.consumerLinkClassName,

                unreadStatusTooltip: value.unreadStatusTooltip,
                unreadStatusClassName: value.unreadStatusClassName,
                loggedInAgentUnreadCount: value.loggedInAgentUnreadCount,

                // sla data
                SLA: value.SLA,
                SLATooltip: value.SLATooltip,
                almostOverdue: value.almostOverdue,

                // skill
                skill: value.skill,

                // last message
                lastContentMessageTooltip: value.lastContentMessageTooltip || '',
                lastContentMessage: value.lastContentMessage || '',
                lastContentMessageTime: value.lastContentMessageTime || '',

                // start time
                startTime: value.startTime || '',

                // Device
                sourceDeviceType: value.sourceDeviceType,
                sourceDeviceTypeTooltip: value.sourceDeviceTypeTooltip,

                // Source
                source: value.source,
                sourceType: value.sourceType,
                sourceTooltip: value.sourceTooltip
            };

            function setSLA() {
                //set SLA in the value object
                if (conversationInfo.responseTime && value.state !== self.conversationStates.closed) {
                    value.SLA = conversationInfo.responseTime.SlaTexts.text;
                    value.SLATooltip = conversationInfo.responseTime.SlaTexts.tooltip;
                } else {
                    value.SLA = '';
                    value.SLATooltip = '';
                }
            }

            function setLastContentEventNotification (context){
                var formattedMessage, escapedMessageText, contentEvent;
                if (!conversationInfo || !conversationInfo.lastContentEventNotification || !conversationInfo.lastContentEventNotification.event ||
                    !(conversationInfo.lastContentEventNotification.event.message || conversationInfo.lastContentEventNotification.event.contentType)) {
                    value.lastContentMessage = '';
                    value.lastContentMessageTooltip = '';
                    return;
                }

                contentEvent = conversationInfo.lastContentEventNotification.event;
                value.lastContentMessageTooltip = '';

                formattedMessage = MessagingUtils.formatLastMessage(contentEvent, conversationInfo.lastContentEventNotification.originatorId);

                value.lastContentMessageTooltip = formattedMessage.formattedMessageTextTooltip;
                value.lastContentMessageTime = lpUtils.formatDateAsString(conversationInfo.lastContentEventNotification.serverTimestamp);

                // the message text will not be escaped in the template injection phase - we only want to escape the parts that are not emojis - so it's escaped here
                escapedMessageText = lpUtils.escapeHTML(formattedMessage.formattedMessageText);
                value.lastContentMessage = escapedMessageText ? lpTag.WebAgent.smileyEmojisController.replaceEmojiCodesByImages(self, true, escapedMessageText) : '';
            }

            function getSubmissionText(context) {
                var secureFormName = getSecureFormName();
                if(secureFormName) {
                    return context.translateObj('secure_form_submit_event_text', [{
                        isTranslate: false,
                        key: secureFormName
                    }]);
                }
                return context.translateObj('secure_form_submit_event_text_generic');
            }

            function getInvitationText(context) {
                return context.translateObj('secure_form_send_event_text', [{
                    isTranslate: false,
                    key: getAgentName()
                },{
                    isTranslate: false,
                    key: conversationInfo.lastContentEventNotification.event.message.title
                }]);
            }

            function getSecureFormName() {
                var currentSecureForm = lpTag.WebAgent.secureFormsController.getSecureFormData(conversationInfo.lastContentEventNotification.event.message.invitationId);
                if(currentSecureForm) {
                    return currentSecureForm.secureFormName;
                }
            }

            function getAgentName() {
                var userProfiles = self.getModelParam('userProfiles');
                var origId = conversationInfo.lastContentEventNotification.originatorId.split('.');
                if(origId.length !== 2) {
                    return;
                }
                var accountId = origId[0];
                var repId = origId[1];
                if(userProfiles && userProfiles[accountId] && userProfiles[accountId][repId]) {
                    return userProfiles[accountId][repId].fullName;
                }
            }

            function setStartTime() {
                value.startTime = lpUtils.formatDateAsString(conversationInfo.startTime);
            }

            function setSkill() {
                value.skill = lpTag.WebAgent.logicController.getSkillName(conversationInfo && conversationInfo.skillId);
            }

            function setSourceDevice() {
                var chatInfo = self.getModelParam('chats.' + conversationInfo.convId + '.chatInfo');

                if(chatInfo.deviceFamily) {
                    value.sourceDeviceType = chatInfo.deviceFamily;
                    value.sourceDeviceTypeTooltip = self.translate("VISIT_INFO_Device_" + chatInfo.deviceFamily);
                }
                else {
                    value.sourceDeviceTypeTooltip = self.translate("VISIT_INFO_Device_NO_DEVICE");
                }
            }

            function setSource() {
                var chatInfo = self.getModelParam('chats.' + conversationInfo.convId + '.chatInfo');

                if (chatInfo && chatInfo.channelSource && chatInfo.channelSource.value) {
                    value.source = chatInfo.channelSource.value.toLowerCase();
                    value.sourceType = chatInfo.channelSource.type;
                    value.sourceTooltip = chatInfo.channelSource.title;
                }
            }
        }
    };

    BaseConnectionsListTableViewController.prototype.dataBinder = {
        modelDataChanged: BaseTableViewController.prototype.baseTableBodyDataBinder.modelDataChanged,
        operationCanceled: BaseTableViewController.prototype.baseTableBodyDataBinder.operationCanceled,
        rowSelected: BaseTableViewController.prototype.baseTableBodyDataBinder.rowSelected,
        rowClicked: function (data, view, event) {
            var conversationInfo = data.rowData;
            // var chatId = conversationInfo.convId;
            // this.modelController.ensureModelData(chatId);

            var target = event && (event.target || event.srcElement);
            var consumerLink = this.getFirstElement(this.LPViewMap.consumerLink, view);
            if (consumerLink && target && target === consumerLink) {
                this.modelController.openConversation(conversationInfo);
                return false;
            }
            BaseTableViewController.prototype.baseTableBodyDataBinder.rowClicked.apply(this, arguments);
        }
    };

    BaseConnectionsListTableViewController.prototype.getShowStatusOptions = function () {
        var StatusFilters = [
            {
                "id": lpAMSController.CONVERSATION_STATES.OPEN,
                text: this.translate(this.translationTexts.connectionsStateFilterOpen),
                icon: 'open'
            },
            {
                "id": lpAMSController.BADGES.FIRST_TIME,
                text: this.translate(this.translationTexts.connectionsStateFilterFirstTime),
                icon: 'first_time'
            },
            {
                "id": lpAMSController.BADGES.URGENT,
                text: this.translate(this.translationTexts.connectionsStateFilterUrgent),
                icon: 'urgent'
            },
            {
                "id": lpAMSController.BADGES.OVERDUE,
                text: this.translate(this.translationTexts.connectionsStateFilterOverdue),
                icon: 'overdue'
            }
        ];

        if (!lpTag.WebAgent.logicController.isMessagingHistoryEnabled()) {
            StatusFilters.push({
                "id": lpAMSController.CONVERSATION_STATES.CLOSE,
                text: this.translate(this.translationTexts.connectionsStateFilterClose),
                icon: 'close'
            });
        }
        return StatusFilters;
    };


    BaseConnectionsListTableViewController.prototype.getColumnsData = function () {
        var modelController = this.getModelControllerInstance();
        var columnsArray = [
            {
                sortTag: "state",
                title: "conversationStatus",
                tooltip: "conversationStatusTooltip",
                tooltipAlign: "left",
                filter: {
                    filterManager: FilterMultiSelectListViewController,
                    filterManagerData: {
                        title: this.translate('filter_status_title_show_status'),
                        className: "conversationStateFilter",
                        filterName: "conversationStates",
                        afterTitle: this.translate("filter_after_title_separator"),
                        filterTextSuffix: "conversationStates",
                        items: this.getShowStatusOptions(),
                        defaultFilter: {
                            selectedItems: modelController.getDefaultValue('filters.conversationStates.selectedItems')
                        },
                        defaultFilterIsActive: true
                    }
                }
            },
            {
                sortTag: "SLA",
                title: "SLA",
                tooltip: "SLATooltip",
                dataPersonalization: 'SLA',
                filter: {
                    filterManager: FilterDurationViewController,
                    filterManagerData: {
                        title: this.translate('filter_duration_title_sla_is'),
                        className: "filter_duration_view",
                        filterName: "sla_duration",
                        availableDurationUnits: [
                            DurationInputViewController.DURATION_UNITS.minutes,
                            DurationInputViewController.DURATION_UNITS.hours,
                            DurationInputViewController.DURATION_UNITS.days
                        ],
                        longerThanRange: {
                            max: 999999,
                            min: -999999
                        },
                        shorterThanRange: {
                            max: 999999,
                            min: -999999
                        },
                        defaultFilter: {
                            comparisonMethod: DurationInputViewController.COMPARISON_OPTIONS.longer,
                            longerThan: 5,
                            shorterThan: 6,
                            durationUnit: DurationInputViewController.DURATION_UNITS.minutes
                        }
                    }
                }
            },
            {
                visitorImage: "visitorImage" //show no title
            },
            {
                title: "consumerName"
            },
            {
                title: "skill",
                tooltip: "conversationSkillTooltip"
            },
            {
                title: "CONVERSATION_START_TIME",
                sortTag: "StartTime"
            },
            {
                title: "LAST_MESSAGE_TIME",
                sortTag: "LastMessageTime"
            }
            // ,
            // {
            //     title: "CONVERSATION_DEVICE"
            // },
            // {
            //     iconType: "browser",
            //     iconState: "other",
            //     tooltip: "CONVERSATION_SOURCE_TOOLTIP"
            // }
        ];
        return columnsArray;
    };


    BaseConnectionsListTableViewController.prototype.getModelControllerInstance = function () {
        // abstract function, must be implemented
        return null;
    };


    return BaseConnectionsListTableViewController;

});
